<div class="filters-bar">
  <div class="filters-left">
    @for (f of filters; track f.key) {
    <div class="filter-item">
      <label class="filter-label">{{ f.label || f.key }}</label>

      <ng-container *ngSwitch="f.type || 'text'">
        <input *ngSwitchCase="'text'" type="text"
               [(ngModel)]="model[f.key]" (ngModelChange)="onFieldChange()" />

        <input *ngSwitchCase="'number'" type="number"
               [(ngModel)]="model[f.key]" (ngModelChange)="onFieldChange()" />

        <input *ngSwitchCase="'date'" type="date"
               [(ngModel)]="model[f.key]" (ngModelChange)="onFieldChange()" />

        <rms-checkbox *ngSwitchCase="'checkbox'"
                      [small]="true"
                      [(ngModel)]="model[f.key]" (ngModelChange)="onFieldChange()">
        </rms-checkbox>

        <select *ngSwitchCase="'select'"
                [(ngModel)]="model[f.key]" (ngModelChange)="onFieldChange()">
          <option [ngValue]="null" disabled selected>All</option>
          @for (opt of f.options ?? []; track $index) {
          <option [ngValue]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </ng-container>
    </div>
    }
  </div>

  <div class="filters-right">
    <button mat-stroked-button class="btn-apply" (click)="onApply()">
      <mat-icon>filter_alt</mat-icon> Apply
    </button>
    <button mat-button class="btn-clear" (click)="onClear()">
      <mat-icon>backspace</mat-icon> Clear
    </button>
    @if(enableSaving){
    <ng-container>
      <button mat-stroked-button [matMenuTriggerFor]="saveMenu">
        <mat-icon>save</mat-icon> Save
      </button>
      <mat-menu #saveMenu="matMenu">
        <div class="save-row">
          <input type="text" placeholder="Filter name" #saveName>
          <button mat-button (click)="save.emit(saveName.value); saveName.value=''">
            <mat-icon>done</mat-icon> Save
          </button>
        </div>
      </mat-menu>

      <button mat-stroked-button [matMenuTriggerFor]="loadMenu">
        <mat-icon>playlist_add_check</mat-icon> Saved
      </button>
      <mat-menu #loadMenu="matMenu" class="saved-filters-menu">
        <div class="saved-header">Saved Filters</div>
        @if(saved.length === 0){
        <div class="saved-empty">No saved filters yet.</div>
        }
        @for (sf of saved; track sf.id) {
        <div class="saved-row">
          <button mat-menu-item (click)="load.emit(sf.id)">
            <mat-icon>play_circle</mat-icon>{{ sf.name }}
          </button>
          <button mat-icon-button title="Delete" (click)="delete.emit(sf.id)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        }
      </mat-menu>
    </ng-container>
    }
  </div>
</div>
